import React, { useState, useEffect } from 'react';
import Header from '../../components/Header';
import moment from 'moment'
import Footer from '../../components/Footer';
import { Row, Col, Input, message, Popconfirm } from 'antd';
import { Table, Button, Form, Select, Tooltip } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import 'antd/dist/antd.css';
import style from './style.module.css';
import api from '../../services/api';
import * as ModalStatusAction from '../../redux/actions/modalStatus'
import * as PermissaoAction from '../../redux/actions/permissao'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useParams } from 'react-router-dom';
import ModalPreCadastro from '../../components/ModalPreCadastro';
import { ParentescoArray } from '../../components/enums/familia.enum';
import { useHistory } from 'react-router-dom';


interface FamiliaProps {
    setPreCadastroModal: any,
    permissao?:any
}

const Familia: React.FC<FamiliaProps> = (props) => {

    let familiar: any;
    let arrayFamiliar: any[] = [];
    const history = useHistory();
    const [index, setIndex] = useState(0);
    const [loadingSelect, setLoadingSelect] = useState(false);
    const [form] = Form.useForm();
    const [dadosCadastrais, setDadosCadastrais] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const { dadosCadastraisID } = useParams<Record<string, string | undefined>>();
    const [familiares, setFamiliares] = useState<any[]>([]);
    const [data, setData] = useState<any[]>([]);
    const [loadingBtnSearch, setLoadingBtnSearch] = useState(false);
    const [arraySelect, setArraySelect] = useState<any[]>();  
    const [dadosDropDown, setDadosDropDow] = useState<any[]>([]);  

    useEffect(() => {    
        getChefeFamiliar().then((res) => {
            getFamiliares();
            getDependentes();  
            getDadosDropDown();
                      
        })
            .catch((err) => {
                message.error(err, 5);
            })
    }, [dadosCadastraisID]);

    useEffect(() => {
        setArraySelect(dadosDropDown.map((option, index) => {

            return <Select.Option key={index} value={option.dadosCadastraisID}>
                {option.nome} - {option.pais} - {moment(option.dataNascimento).format('DD/MM/YYYY')}
            </Select.Option>
        }))
        getDependentes(); 
    }, [dadosDropDown]);

    useEffect(() => {
        mapFamilia();
    }, [familiares, dadosCadastrais]);

    const mapFamilia = () => {
        try {
            setData(familiares.map(item => {
                return {
                    key: item?.familiarID,
                    familiarID: item?.familiarID,

                    nome: dadosCadastrais.filter((element: any) => { return element.dadosCadastraisID == item.dadosCadastraisParenteID })[0]?.nome,

                    dadosCadastraisID: item?.dadosCadastraisID,
                    dadosCadastraisParenteID: item?.dadosCadastraisParenteID,
                    parentesco: item?.parentesco,
                    parentescoLabel: ParentescoArray.filter((parentesco) =>
                        item?.parentesco === parentesco.value)[0].descricao
                } || ''
            }))

            
        }
        catch (err) {
            message.error('Falha em resgatar os familiares')
        }
    }
    const getChefeFamiliar = async () => {

        return new Promise<any>(async (resolve, reject) => {
            api.get(`DadosCadastrais/getchefefamiliar?id=${dadosCadastraisID}`)
                .then(response => {
                    resolve(true)
                    history.push(
                        `/familia/${response.data.dadosCadastraisID}`);
                    form.setFieldsValue({ chefeFamilia: response?.data?.nome });
                })
                .catch(err => {
                    reject(err?.response?.data ? err?.response?.data : 'Falha na requisição')

                    history.push('/dados-cadastrais/consulta');
                })
        });

    }

    const getFamiliares = async () => {
        setLoading(true);
        await api.get(`Familiar/getByDadosCadastraisID?id=${dadosCadastraisID}`)
            .then(response => {

                response?.data?.forEach((e: any) => {
                    familiar = {
                        key: e.familiarID,
                        familiarID: e.familiarID,
                        dadosCadastraisID: e.dadosCadastraisID,
                        dadosCadastraisParenteID: e.dadosCadastraisParenteID,
                        parentesco: e.parentesco
                    }
                    arrayFamiliar.push(familiar);
                });
                setFamiliares(arrayFamiliar);
            })
            .catch(() => {

                message.error("Falha na requisição");

            })
            .finally(() => {
                setLoading(false);
            })
    }
    const getDependentes = async (): Promise<any> => {        
        await api.get(`DadosCadastrais/getdependentes`,)
            .then(response => {
                setDadosCadastrais(response?.data?.filter((item: any) => { return item.dadosCadastraisID != dadosCadastraisID }));
            })
            .catch(() => {
            })
            .finally(() => {                
            })
    }

    const getDadosDropDown = async (): Promise<any> => {

        setLoadingBtnSearch(true)
        await api.get(`DadosCadastrais/getpopularDropDependentes`,)
            .then(response => {
                setDadosDropDow(response?.data);
            })
            .catch(() => {
            })
            .finally(() => {
                setLoadingBtnSearch(false);
            })
    }


    const vincularFamiliar = async () => {
        setLoading(true)
        await api.post('Familiar',
            {
                DadosCadastraisID: dadosCadastraisID ? parseInt(dadosCadastraisID) : 0,
                DadosCadastraisParenteID: form.getFieldValue('dadosCadastraisParenteID'),
                Parentesco: form.getFieldValue('parentesco')
            })
            .then((response) => {

                setFamiliares([{
                    key: response?.data.familiarID,
                    familiarID: response?.data.familiarID,
                    dadosCadastraisID: response?.data.dadosCadastraisID,
                    dadosCadastraisParenteID: response?.data.dadosCadastraisParenteID,
                    parentesco: response?.data.parentesco

                }, ...familiares])

                message.success('Incluído com sucesso')
            })
            .catch((err) => {
                message.error(err?.response?.data ? err?.response?.data : 'Falha na requisição')
            })
            .finally(() => {
                api.post(`Familiar/atualizarDadosImigracaoFamiliar?dadosCadastraisID=${dadosCadastraisID ? parseInt(dadosCadastraisID) : 0}&dadosCadastraisFamiliarID=${form.getFieldValue('dadosCadastraisParenteID')}`)
                .then((response)=>{
                })
                .catch((err) => {
                    message.warning(err?.response?.data ? err?.response?.data.message : 'Falha na requisição')
                })
                setLoading(false);
            })

    }
    const deletarFamiliar = async (id: number) => {

        setLoading(true);
        await api.delete(`Familiar?id=${id}`).then(err => {
            setFamiliares(familiares.filter(item => item?.familiarID !== id));
            message.success('removido com sucesso');
        })
            .catch(() => {
                message.error('Falha na requisição');
            })
            .finally(() => {
                setLoading(false);
            })
    }

    const atualizarFamiliar = (familiar: any, newValue: any) => {
        setLoadingSelect(true);
        setIndex(familiar.familiarID);
        api.put(`Familiar`, {
            FamiliarID: familiar.familiarID,
            DadosCadastraisID: familiar.dadosCadastraisID,
            DadosCadastraisParenteID: familiar.dadosCadastraisParenteID,
            Parentesco: newValue
        })
            .catch(err => { message.error('Falha em atualizar o familiar!') })
            .finally(() => setLoadingSelect(false))

    }
    const columns = [
        { title: 'Nome', dataIndex: 'nome', },

        {
            title: 'Parentesco',
            dataIndex: 'parentescoLabel',
            render: (text: any, record: any) => (
                <>
                    {  props.permissao[0].permissaoAcesso?.editar === true ? <Select key={record.key} loading={loadingSelect && index == record.familiarID}
                        onChange={(newValue) => atualizarFamiliar(record, newValue)} defaultValue={record.parentesco} style={{ width: 140 }} placeholder="Selecione">

                        {ParentescoArray.map((item, index) => {
                            return <Select.Option key={index} value={item.value}>{item.descricao}</Select.Option>
                        })}
                    </Select>
                        :
                        <p>{ParentescoArray.filter((parentesco) =>
                            record.parentesco === parentesco.value)[0].descricao}</p>

                    }
                </>
            ),
        },

        {
            title: 'Açao',
            dataIndex: '',
            key: 'x',
            render: (text: any, record: any) => (
                <>{props.permissao[0].permissaoAcesso?.excluir === true ?
                    <Popconfirm key={record.key} placement="top" title="Você tem certeza que deseja remover esse familiar?" onConfirm={(e) => { deletarFamiliar(record.key); }} okText="Sim" cancelText="Não">
                        <Button key={record.key} >  Remover Familiar </Button>
                    </Popconfirm>

                    : null}
                </>
            ),
        }

    ];     

    return (
        <>
            <Header />
            <br />
            <div className="container">
                <fieldset className="fieldset-consulta">
                    <Row align="middle" justify="center">
                        <Col span={24} >
                            <Form
                                labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}
                                name="familia"
                                form={form}
                            >
                                <div className="row">
                                    <div className="col-md-12">
                                        <Form.Item
                                            label="Chefe da família"
                                            name="chefeFamilia">
                                            <Input readOnly />

                                        </Form.Item>

                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-8">

                                        <Form.Item
                                            label="Dependente"
                                        >

                                            <Row>
                                                <Col span={23}>
                                                    <Form.Item name="dadosCadastraisParenteID" noStyle>
                                                        <Select
                                                            showSearch
                                                            placeholder="Selecione"
                                                            optionFilterProp="children"
                                                            disabled={!props.permissao[0].permissaoAcesso?.cadastrar}
                                                        >
                                                            {arraySelect}
                                                        </Select>
                                                    </Form.Item>
                                                </Col>
                                                <Col span={1}>
                                                    <Tooltip title="search">
                                                        <Button type="primary" onClick={getDadosDropDown} icon={<SearchOutlined />} loading={loadingBtnSearch} />
                                                    </Tooltip>
                                                </Col>
                                            </Row>

                                        </Form.Item>
                                    </div>
                                    <div className="col-md-4">
                                        <Form.Item
                                            label="Parentesco"
                                            name="parentesco"
                                        >
                                            <Select placeholder="Selecione" disabled={!props.permissao[0].permissaoAcesso?.cadastrar}>
                                                {ParentescoArray.map((item, index) => {
                                                    return <Select.Option key={index} value={item.value}>{item.descricao}</Select.Option>
                                                })}
                                            </Select>
                                        </Form.Item>
                                    </div>
                                </div>
                                <div className="row">

                                    <div className="col-md-2">
                                        <Form.Item>
                                            {props.permissao[0].permissaoAcesso?.cadastrar === true ?
                                                <Button type="primary" onClick={() => { vincularFamiliar() }}>
                                                    Adicionar Familiar
                                                </Button>
                                                : null
                                            }
                                        </Form.Item>
                                    </div>
                                    <div className="col-md-2">
                                        <Form.Item>
                                            {props.permissao[0].permissaoAcesso?.cadastrar === true ?
                                                <Button type="primary" htmlType="submit" onClick={() => { props.setPreCadastroModal(true) }}>
                                                    Pré-Cadastro
                                                </Button>
                                                : null
                                            }
                                        </Form.Item>
                                    </div>
                                </div>
                            </Form>
                        </Col>
                    </Row>
                </fieldset>
                <br />
                <Row align="middle" justify="center">
                    <Col span={24}>
                        <Table
                            bordered
                            style={{ maxHeight: 480 }}
                            columns={columns}
                            dataSource={data}
                            key={"familiarID"}
                            pagination={{ pageSize: 5 }}
                            loading={loading}>
                        </Table>
                        <Button type="primary" style={{ marginTop: 20 }} onClick={ ()=>history.push(`/dados-cadastrais/consulta`)}>  Voltar </Button>
                    </Col>
                    
                </Row>
               
            </div>
            <ModalPreCadastro></ModalPreCadastro>
            <Footer />
        </>
    );
}


const mapStateToProps = (state: any) => ({
    modalStatus: state.modalStatus,
    permissao: state.permissao
})

const mapDispatcToProps = (dispatch: any) => 
{     
    return  bindActionCreators(Object.assign({},PermissaoAction, ModalStatusAction), dispatch);    
}

export default connect(mapStateToProps, mapDispatcToProps)(Familia);